export default __webpack_public_path__ + "static/media/uploader-abbottLibre-4.54bc520f.png";